import {
  Box, Container, VStack, Text, CardBody, Image,
} from "@chakra-ui/react";
import { useEffect } from "react";
import AppPage from "layouts/AppPage";
import { useNavbar } from "hooks/useNavbar";
import { useAnalytics } from "services/analytics";
import useCaminoStore from "stores/caminoStore";
import HangOutSVG from "assets/undraw_hang_out.svg";
import TransparentCard from "components/Card/TransparentCard";

export default function HangoutPage() {
  const { setPageTitle } = useNavbar();
  const { trackPageView } = useAnalytics();
  const currentUser = useCaminoStore((state) => state.currentUser);
  const firstName = currentUser?.fullName?.split(" ")[0];

  useEffect(() => {
    setPageTitle(`Welcome${firstName ? `, ${firstName}` : "!"}`);
    return () => {
      setPageTitle(null);
    };
  }, [setPageTitle, firstName]);

  useEffect(() => {
    trackPageView("hangout", { page_type: "basic_landing" });
  }, [trackPageView]);

  return (
    <AppPage>
      <Box minH="100vh" bg="gray.50" py={8}>
        <Container maxW="800px">
          <TransparentCard>
            <CardBody>
              <VStack spacing={6} align="center" textAlign="center" py={8}>
                <Image mx={6} maxWidth="320px" maxHeight="320px" src={HangOutSVG} alt="Person relaxing" />
                <VStack spacing={2}>
                  <Text fontSize="2xl" fontWeight="semibold" color="content.primary">
                    Nothing to see here... yet!
                  </Text>
                  <Text fontSize="md" color="content.tertiary" maxW="500px">
                    You don&apos;t have any active tasks or onboarding journeys right now. Check back later, or we&apos;ll notify you when you have something relevant to review.
                  </Text>
                </VStack>
              </VStack>
            </CardBody>
          </TransparentCard>
        </Container>
      </Box>
    </AppPage>
  );
}
